import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=739be830&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=739be830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739be830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('739be830')) {
      api.createRecord('739be830', component.options)
    } else {
      api.reload('739be830', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=739be830&scoped=true&", function () {
      api.rerender('739be830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qsD63JvpkJec/JS/comp/PopupBox.vue"
export default component.exports